export default {"src":"/_next/static/media/favicon.76373fd1.ico","height":28,"width":28,"blurWidth":0,"blurHeight":0};